import {globalSlice, callTypes} from './Slice';

const {actions} = globalSlice;

export const setRandom = () => (dispatch) => {
  dispatch(actions.setRandom());
};

export const setBranches = (data) => (dispatch) => {
  dispatch(actions.setBranches(data));
};

export const setCurrentBranch = (data) => (dispatch) => {
  dispatch(actions.setCurrentBranch(data));
};
export const setIpAddress = (data) => (dispatch) => {
  dispatch(actions.setIpAddress(data));
};
